import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from 'services/_infra/rtkBaseQuery';

export const widgetsApi = createApi({
  reducerPath: 'widgetsApi', // This is the name of the slice in the store
  baseQuery: axiosBaseQuery(), // Custom axios base query (calls apiClient with the query url and params)
  tagTypes: ['Widgets'], // Used to track when refetches are needed
  endpoints: (builder) => ({
    getUserWidgetData: builder.query({
      query: () => ({
        url: '/widgets/layout',
      }),
      transformResponse: (response) => response.widgets,
      providesTags: ['Widgets'], // Tells RTK Query this query provides 'Widgets' data and to refetch when invalidated
    }),
    updateUserWidgetLayout: builder.mutation({
      query: (layout) => ({
        url: '/widgets/layout',
        method: 'PUT',
        data: {
          widgetLayout: JSON.stringify(layout),
        },
      }),
      invalidatesTags: ['Widgets'], // Tells RTK Query to refetch any queries that provide this tag
    }),
  }),
});

export const { useGetUserWidgetDataQuery, useUpdateUserWidgetLayoutMutation } = widgetsApi;
